import { useNavigate } from 'react-router-dom';
import { DataGrid } from '@/components/data-grid';
import { ROUTES } from '@/app/routes';
import { useAdminTable } from '../api';
import { adminColumns } from '../columns';
import type { AccountViewResponseDTO } from '../types';

/**
 * Admin list is read-only and sourced from Microsoft Entra App Role assignees
 * (login-capable users only) — not MySQL admin rows (TM-3368).
 */
export function AdminListPage() {
  const navigate = useNavigate();
  const table = useAdminTable();

  return (
    <DataGrid<AccountViewResponseDTO>
      title="Admin List"
      searchPlaceholder="Search admins..."
      columns={adminColumns}
      rows={table.rows}
      total={table.total}
      isLoading={table.isLoading}
      isFetchingNextPage={table.isFetchingNextPage}
      isError={false}
      endReached={table.endReached}
      page={table.page}
      totalPage={table.totalPage}
      onPageChange={table.setPage}
      isFetching={table.isFetching}
      onLoadMore={table.fetchNextPage}
      search={table.search}
      onSearchChange={table.setSearch}
      onRetry={() => void table.refetch()}
      onRowClick={(row) => {
        // Real DTO id field is `adminId`.
        if (row.adminId != null) void navigate(ROUTES.adminDetails(String(row.adminId)));
      }}
      getRowId={(row) => String(row.adminId)} // dedupe across pages (fixes CMP dup-key defect)
      emptyMessage="No Entra admin accounts"
    />
  );
}
